import { render, staticRenderFns } from "./RecoverTodayList.vue?vue&type=template&id=363f6902&scoped=true&"
import script from "./RecoverTodayList.vue?vue&type=script&lang=js&"
export * from "./RecoverTodayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f6902",
  null
  
)

export default component.exports